import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Tooltipable } from "@ui/tooltips/tooltipable";
import { FavoriteOffIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";

interface BookmarkToggleProps extends React.HTMLAttributes<HTMLDivElement> {
	checked: boolean;
	onClick: () => void;
}

export const BookmarkToggle: React.FC<BookmarkToggleProps> = ({ checked, onClick, ...htmlProps }) => {
	return (
		<Tooltipable text={I18n.t("course.bookmark_title")}>
			<Container
				{...htmlProps}
				onClick={(e) => {
					e.preventDefault();
					onClick();
				}}
			>
				<FavoriteOffIcon toggled={checked} />
			</Container>
		</Tooltipable>
	);
};

const Container = styled.div`
	cursor: pointer;
	background-color: ${({ theme }) => theme.colors.backgroundPrimary};
	${row(0, "center", "center")};
	width: 32px;
	height: 32px;
	border-radius: 16px;

	svg {
		width: 15px;
	}
`;
